
import glamorous from 'glamorous'

import * as colours from '../../../../../styles/colours'
// const brand = require('../../../../../images/virtu-brand.svg')

export const StyledLoginWrapper = glamorous.section({
  display: 'flex',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  padding: 20,
  flexDirection: 'column',
  background: `${colours.brandBls}`,
  justifyContent: 'center',
  alignItems: 'center',
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Login/components/LoginWrapper/LoginWrapper.glamorous.tsx